'use strict'

module.exports = {
  blockquote: require('./blockquote'),
  break: require('./break'),
  code: require('./code'),
  delete: require('./delete'),
  emphasis: require('./emphasis'),
  footnoteReference: require('./footnote-reference'),
  footnote: require('./footnote'),
  heading: require('./heading'),
  html: require('./html'),
  imageReference: require('./image-reference'),
  image: require('./image'),
  inlineCode: require('./inline-code'),
  linkReference: require('./link-reference'),
  link: require('./link'),
  listItem: require('./list-item'),
  list: require('./list'),
  paragraph: require('./paragraph'),
  root: require('./root'),
  strong: require('./strong'),
  table: require('./table'),
  text: require('./text'),
  thematicBreak: require('./thematic-break'),
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

/* Return nothing for nodes which are ignored. */
function ignore() {
  return null
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/index.js
// module id = 896
// module chunks = 95715928098905 168707334958949